import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { SalvButton, SalvModal, SalvTextField, Size } from '@salvapp/ui-components';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';

import * as Yup from 'yup';
import { finalRiskApi } from '../apis';
import { useDispatch } from 'react-redux';
import { setRefresh } from '../table/redux/tablesReducer';
import { AddOverrideReasonRequest } from '../api-internal';

export interface AddFinalRiskOverrideReasonFormValues {
  reason?: string;
  description?: string;
}

const validationSchema = Yup.object().shape({
  reason: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
});

export const AddFinalRiskOverrideReasonsModal = () => {
  const [showModal, setShowModal] = useState(false);
  const initialValues: AddFinalRiskOverrideReasonFormValues = {
    reason: '',
    description: '',
  };
  const dispatch = useDispatch();

  const submit = async (
    values: AddFinalRiskOverrideReasonFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AddFinalRiskOverrideReasonFormValues>
  ) => {
    setSubmitting(true);
    const request = {
      internalApiAddFinalRiskOverrideReason: {
        reason: values.reason,
        description: values.description,
      },
    } as AddOverrideReasonRequest;
    await finalRiskApi.addOverrideReason(request);
    setShowModal(false);
    resetForm();
    dispatch(setRefresh({ name: 'riskOverrideReasons', shouldRefresh: true }));
  };

  return (
    <>
      <div>
        <SalvButton
          label='Add new reason'
          ariaLabel='add new reason'
          variant='muted'
          size={Size.SMALL}
          onClick={() => {
            setShowModal(true);
          }}
        />
      </div>
      <Formik initialValues={initialValues} onSubmit={submit} validationSchema={validationSchema}>
        {({ values, isSubmitting, setFieldValue, isValid }: FormikProps<AddFinalRiskOverrideReasonFormValues>) => (
          <SalvModal show={showModal} onHide={() => setShowModal(false)}>
            <Form>
              <SalvModal.Header closeButton>Add new reason</SalvModal.Header>
              <SalvModal.Body>
                <Row>
                  <Col md={12}>
                    <div className='row'>
                      <div className='col'>
                        <SalvTextField
                          label='Reason'
                          ariaLabel='reason'
                          placeholder='Enter here'
                          value={values.reason}
                          onChange={(v: string) => setFieldValue('reason', v)}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col mt-3'>
                        <SalvTextField
                          label='Description'
                          ariaLabel='description'
                          placeholder='Enter here'
                          value={values.description}
                          onChange={(v: string) => setFieldValue('description', v)}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </SalvModal.Body>
              <SalvModal.Footer>
                <SalvButton label='Close' ariaLabel='close' variant='muted' onClick={() => setShowModal(false)} />
                <SalvButton
                  label='Save'
                  ariaLabel='save'
                  disabled={isSubmitting || !isValid}
                  type='submit'
                  variant='primary'
                />
              </SalvModal.Footer>
            </Form>
          </SalvModal>
        )}
      </Formik>
    </>
  );
};
